import { createFileRoute } from '@tanstack/react-router'

import { NnppImportProcessingPage } from '@/src/pages/nnpp/imports/NnppImportProcessingPage'

export const Route = createFileRoute(
  '/nnpp/imports/$importId/documents/$documentId/import'
)({
  component: NnppImportProcessingPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
